module.exports = __webpack_public_path__ + "img/av139.d297d62f.png";